import React, { createContext, useContext } from "react"

import { Room } from "shared/types/Room"
import { SelectOption } from "shared/types/Select"

export interface ProductPositionFormSelectionContextValue {
  projectOptions?: SelectOption<string>[]
  roomOptions?: SelectOption<string, Room>[]
  positionOptions?: SelectOption<number>[]
}

const ProductPositionFormSelectionContext = createContext<
  ProductPositionFormSelectionContextValue | undefined
>(undefined)

export interface ProductPositionFormSelectionProviderProps {
  value: ProductPositionFormSelectionContextValue
  children: React.ReactNode
}

export const ProductPositionFormSelectionProvider = React.memo(
  ({ value, children }: ProductPositionFormSelectionProviderProps) => (
    <ProductPositionFormSelectionContext.Provider value={value}>
      {children}
    </ProductPositionFormSelectionContext.Provider>
  )
)

export function useProductPositionFormSelectionContext(): ProductPositionFormSelectionContextValue {
  const context = useContext(ProductPositionFormSelectionContext)
  if (!context) {
    throw new Error(
      "useProductPositionFormSelectionContext must be used within a ProductPositionFormSelectionProvider"
    )
  }
  return context
}
